module.exports = __webpack_public_path__ + "static/media/mainicon1.b006cccd.png";